import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    cursor: none;
  }

  /* Respect the OS setting — this site is heavily animated. */
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.001ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.001ms !important;
      scroll-behavior: auto !important;
    }
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }

  body {
    /* Same treatment the About section uses, applied site-wide. */
    background: linear-gradient(180deg, #0a0a0a 0%, #0d0a14 30%, #0d0a14 70%, #0a0a0a 100%);
    background-attachment: fixed;
    background-attachment: fixed;
    color: #f2eeea;
    font-family: 'Raleway', -apple-system, BlinkMacSystemFont, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    line-height: 1.6;
    letter-spacing: 0.01em;
    cursor: none;
  }

  #root {
    min-height: 100vh;
  }

  h1, h2, h3, h4, h5, h6 {
    color: #fdfaf7;
    line-height: 1.3;
  }

  p {
    line-height: 1.7;
    color: #ded7d0;
  }

  ::selection {
    background: rgba(196, 148, 42, 0.4);
    color: #fff;
  }

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #17161a;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, rgba(196, 148, 42, 0.32), rgba(150, 110, 40, 0.22));
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, rgba(196, 148, 42, 0.55), rgba(150, 110, 40, 0.4));
  }

  a {
    color: inherit;
    text-decoration: none;
    cursor: none;
  }

  button, input, textarea, select {
    cursor: none;
  }

  section {
    position: relative;
  }

  /* The ambient bloom that sits behind the About section, made global. */
  body::after {
    content: "";
    position: fixed;
    top: 42%;
    left: 50%;
    transform: translateX(-50%);
    width: 700px;
    height: 700px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(139, 92, 246, 0.05) 0%, transparent 70%);
    filter: blur(60px);
    pointer-events: none;
    z-index: 0;
  }

  /* 3D grid lines */
  body::before {
    content: "";
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(255, 236, 205, 0.022) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 236, 205, 0.022) 1px, transparent 1px);
    background-size: 50px 50px;
    perspective: 600px;
    transform: rotateX(45deg);
    transform-origin: center 120%;
    mask-image: linear-gradient(180deg, transparent 34%, rgba(0,0,0,0.28) 55%, rgba(0,0,0,0.34) 72%, transparent 92%);
    -webkit-mask-image: linear-gradient(180deg, transparent 34%, rgba(0,0,0,0.28) 55%, rgba(0,0,0,0.34) 72%, transparent 92%);
  }

  body::after {
    content: "";
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background-image:
      radial-gradient(ellipse at 50% 100%, rgba(139, 92, 246, 0.02), transparent 60%);
  }
`;

export default GlobalStyles;
